import { Component, ViewChild } from '@angular/core';
import { CrudService } from 'src/app/services/crud.service';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { NotifyService } from 'src/app/services/notify.service';

@Component({
    selector: 'app-suppliers',
    templateUrl: './suppliers.component.html',
    styleUrls: ['./suppliers.component.css'],
    imports: [DxDataGridModule],
    standalone: true
})
export class SuppliersComponent {
  private apiUrl: string = environment.baseApiUrl;
  dataSource: any;
  editSuppliers: boolean = false;

  @ViewChild("suppliersGrid", { static: false }) public dataGrid: DxDataGridComponent;

  constructor(private crudService: CrudService,
    private horizontalMenuService: HorizontalMenuService,
    private confirmationService:ConfirmationService,
    private notifyService:NotifyService)
  {
    this.horizontalMenuService.editSuppliers$.subscribe((value: boolean) => {
      this.editSuppliers = value;
      if(this.editSuppliers) {
        this.dataSource = new CustomStore<any>({
          key: 'id',
          load: async () => {
            return await new Promise((resolve) => {
              this.crudService.getData(`${this.apiUrl}suppliers`).subscribe((result: any) => {
                resolve({data: result, totalCount: result.length});
              })
            })
        },
          insert: async (values) => {
            const userDetails = localStorage.getItem('userDetails');
            const parsedDetails = JSON.parse(userDetails || '{}');
            values.group_id = parsedDetails.data.group_id;
            values.location_id = parsedDetails.data.location_id;
            return await new Promise(async (resolve) => {
              await this.crudService.insertData(`${this.apiUrl}suppliers`, values).subscribe((result: any) => {
                this.notifyService.tellUser(result);
                resolve(result);
              });
            });
          },
          update: async (key, values) => {
            return await new Promise(async (resolve) => {
              await this.crudService.updateData(`${this.apiUrl}suppliers`, key, values).subscribe((result: any) => {
                this.notifyService.tellUser(result);
                resolve(result);
              });
            });
          },
          remove: async (key) => {
            return await new Promise(async (resolve) => {
              await this.crudService.deleteData(`${this.apiUrl}suppliers`, key).subscribe((result: any) => {
                this.notifyService.tellUser(result);
                resolve(result);
              });
            });
          }
        });
      }
    });
  }
  onHiding(event: any) {
    this.confirmationService.checkUnsaved(event, this.dataGrid, (value: boolean) => {
        this.horizontalMenuService.seteditSuppliers(value);
    });
    this.horizontalMenuService.seteditSuppliers(false);
  }
}
